import Project1 from '../../assets/images/mediwise.jpg'
import Project2 from '../../assets/images/salaar.jpg'
import Project3 from '../../assets/images/craftman.jpg'
import Project4 from '../../assets/images/noteapp.jpg'
import Project5 from '../../assets/images/shunya.png'
import Project6 from '../../assets/images/portfolio.png'
import Project7 from '../../assets/images/epsilon.png'
import Project8 from '../../assets/images/weal.png'
import Project9 from '../../assets/images/qrgenerator.jpg'
import Project10 from '../../assets/images/atmC.jpg'
import Project11 from '../../assets/images/movie_recommand.png'
import Project12 from '../../assets/images/whatsapp_chat.png'

export const projectsData = [
  {
    id: 1,
    image: Project1,
    category: 'WEB',
    title: 'Mediwise PWA App',
    description:
      'Comprehensive healthcare management system for hyperlocal medical setups such as hospitals and clinics.',
    github: 'https://github.com/its-abhishek/Ingenius-12.0',
  },
  {
    id: 2,
    image: Project2,
    title: 'Salaar Part 1 - Ceasefire Movie Official Website',
    category: 'WEB',
    description:
      'The official movie website, leading world-wide Salaar Fan Army & Creative Squad campaigns.',
    github: 'https://github.com/its-abhishek/Salaar-Campaign-HombaleFilms',
    demo: 'https://www.salaar.army/',
  },
  {
    id: 3,
    image: Project3,
    title: 'Environmental Sensors Monitoring System PWA',
    category: 'WEB',
    description:
      'To manage IoT devices using optimization algorithm for route-based task sequencing and streamlined employee routes.',
    github:
      'https://github.com/its-abhishek/Craftsman-Management-System-routing',
  },
  {
    id: 4,
    image: Project4,
    title: 'Note taking app built using MERN Stack',
    category: 'WEB',
    description:
      'Save notes and delete unused ones using this modern, self-managed application.',
    github: 'https://github.com/its-abhishek/mern-project',
  },
  {
    id: 5,
    image: Project5,
    title: 'Static Shunya Club Website',
    category: 'WEB',
    description:
      'Website for Shunya, The Official Math Club of PES University.',
    github: 'https://github.com/its-abhishek/Shunya/tree/main',
    demo: 'https://shunyapes.vercel.app/',
  },
  {
    id: 6,
    image: Project6,
    category: 'WEB',
    title: 'React - Personal Portfolio website',
    description: 'Personal portfolio website to display my work and projects.',
    github: 'https://github.com/its-abhishek/AbhishekHonnapure',
    demo: 'https://abhishek-honnapure.vercel.app/',
  },
  {
    id: 7,
    image: Project7,
    category: 'WEB',
    title: 'Static E-Commerce website',
    description: 'A single page consulting website',
    github: 'https://github.com/its-abhishek/epsilontechnologies',
    demo: 'https://epsilontechnologies.vercel.app/',
  },
  {
    id: 8,
    image: Project8,
    category: 'WEB',
    title: 'Weal - The Health Clube website',
    description:
      'Website for Weal, The Official Health Club of PES University.',
    github: 'https://github.com/its-abhishek/Website2023/tree/main',
  },
  {
    id: 9,
    image: Project9,
    category: 'Other',
    title: 'Generating a Unique QR Code using Python',
    description: 'Using Tkinter',
    github: 'https://github.com/its-abhishek/Python-Project',
  },
  {
    id: 10,
    image: Project10,
    category: 'Other',
    title: 'Working Process of ATM Machine Using C',
    description: 'CLI based Project',
    github: 'https://github.com/its-abhishek/C-Projects',
  },
  {
    id: 11,
    image: Project11,
    category: 'ML',
    title: 'Movie Recommender System',
    description: 'Its ML based Project',
    github: 'https://github.com/its-abhishek/movie_recommendation_system',
    demo: 'https://movie-recommendation-systemm.streamlit.app/',
  },
  {
    id: 12,
    image: Project12,
    category: 'ML',
    title: 'Whatsapp Chat Analyzer',
    description: 'Its ML based Project',
    github: 'https://github.com/its-abhishek/whatsapp_chat_analysis',
    demo: 'https://whatsapp-chat-analysiss.streamlit.app/',
  },
]

export const projectsNav = [
  {
    name: 'All',
  },
  {
    name: 'WEB',
  },
  {
    name: 'ML',
  },
  {
    name: 'Other',
  },
]
